var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.varOrItemImage
        ? [
            _vm._l(_vm.varOrItemImage, function (img) {
              return [
                _c("div", { staticClass: "my-5 item" }, [
                  _c("picture", [
                    _c("source", { attrs: { srcset: img.url } }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "img-fluid",
                      attrs: {
                        src: img.url,
                        alt: _vm.currentVariation.texts.name1,
                        title: _vm.currentVariation.texts.name1,
                      },
                    }),
                  ]),
                ]),
              ]
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }